import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { sendDailyPing } from './usage/goactoPing';
import { isBreathePath } from './breathe/session';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function renderRoot(node: React.ReactNode) {
  root.render(<ErrorBoundary>{node}</ErrorBoundary>);
}

// /breathe is free and has no sign-in. Load it on its own so this route
// does not start Firebase auth, Firestore, or the daily usage ping.
if (isBreathePath(window.location.pathname)) {
  void import('./breathe/BreathePage').then(({ default: BreathePage }) => {
    renderRoot(<BreathePage />);
  }).catch(() => {
    root.render(<p className="p-6 text-center">This page did not load. Refresh to try again.</p>);
  });
} else {
  const path = window.location.pathname;
  const isBotOwnerRoute = path === '/bots' || path.startsWith('/bots/');

  // GOACTO anonymous daily usage count (REQ v0.3.1 §4.6). Skips on opt-out or GPC; never blocks UI.
  void sendDailyPing('focus_log', { storage: window.localStorage, fetch: window.fetch.bind(window) });

  // Sentry is optional and heavy (~100KB+ gzip in main). Never block first paint / App import.
  void import('./sentry').then((m) => { try { m.initSentry(); } catch { /* ignore */ } });

  if (isBotOwnerRoute) {
    void import('./components/bots/BotOwnerPage').then(({ default: BotOwnerPage }) => {
      renderRoot(<BotOwnerPage />);
    });
  } else {
    void import('./App').then(({ default: App }) => {
      renderRoot(<App />);
    });
  }

  // No-op unless a handler is passed. Kept off /breathe.
  reportWebVitals();
}
